module.exports = __webpack_public_path__ + "img/icon_error@2x.f4509049.png";